import axios from 'axios'
import Swiper from 'swiper'
import SwiperCore, {Navigation} from 'swiper/core'
import { getLocalURL } from '../../../scripts/helpers/globale'

SwiperCore.use([Navigation])

export default class ProductRecommendations {
  constructor(component) {
    this.dom = {
      $component: component,
      $container: component.querySelector('.js-productSliderContainer'),
      $prev: component.querySelector('.js-productSliderPrev'),
      $next: component.querySelector('.js-productSliderNext')
    }
    this.state = {

    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.getRecommendations()
  }

  async getRecommendations() {
    const {dom} = this
    const productId = dom.$component.dataset.productId
    const url = getLocalURL(`/recommendations/products?product_id=${productId}&section_id=product-recommendations&limit=7`)

    try {
      const response = await axios.get(url)
      const mountCards = new Event('mountproductcards')
      const container = document.createElement('div')
      container.innerHTML = response.data
      const slides = container.querySelector('.js-productSliderContainer .swiper-wrapper')
      dom.$container.querySelector('.swiper-wrapper').innerHTML = slides.innerHTML
      document.dispatchEvent(mountCards)
      this.initMainSlider()
    } catch(e) {
      console.log('Error getting product recommendations', e)
    }
  }

  initMainSlider() {
    const {dom} = this
    const swiper = new Swiper(dom.$container, {
      breakpoints: {
        1024: {
          slidesPerView: 'auto'
        }
      },
      navigation: {
        prevEl: dom.$prev,
        nextEl: dom.$next
      }
    })
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ProductRecommendations = this
  }
}
